import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

export default class RequestScreenshotDialog extends Component {
  getDevices = () => {
    const { devices } = this.props;
    const names = devices.map((item, index) => (
      <li key={index}>
        <code>{item.name}</code> {item.description}
      </li>
    ));

    return <ol>{names}</ol>;
  };

  render() {
    const { show, onHide, onSuccess, devices } = this.props;

    if (!devices) {
      return null;
    }

    const plural = devices.length > 1 ? 's' : '';

    return (
      <Modal
        data-test="modal-requestscreenshot"
        dialogClassName="device-dialog"
        show={show}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title data-test="modal-requestscreenshot-title">
            Request Device Screenshot
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Request screenshot{plural} from:</p>
          {this.getDevices()}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onHide}>
            Cancel
          </Button>
          <Button
            data-test="modal-requestscreenshot-button-request"
            className="btn-add"
            bsStyle="primary"
            onClick={onSuccess}
          >
            Request Screenshot{plural}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

RequestScreenshotDialog.propTypes = {
  devices: PropTypes.array,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
